import { observable, action, computed, autorun } from "mobx";

import { BaseStore, Delay } from "./BaseStore";

import { HorsesEndpoints } from "../endpoints/HorseEndpoints";
import { HorseForSaleEndpoints } from "../endpoints/HorseForSaleEndpoints";

import { Horse } from "../model/Horse";
import { SimpleHorseForSale } from "../model/HorseForSale";

import { MultiPatchRequest, PatchRequest } from "../requests/PatchRequests";
import { CreateHorseForSaleRequest } from "../requests/HorseForSaleRequests";

export class HorseStore extends BaseStore {
    @observable private _horseId: number;
    @observable private _horse: Horse;

    constructor(private horseEndpoints: HorsesEndpoints, private horseForSaleEndpoints: HorseForSaleEndpoints) {
        super();
    }

    @action async updateSubjectId(id: number) {
        this._horseId = id;
    }

    @action async refresh(): Promise<Horse> {
        this.setLoading();
        try {
            this._horse = await this.horseEndpoints.getHorse(this._horseId);

            this.setReady();
            return this._horse;
        } catch (e) {
            this.setError(e ? e.message || e : "An unknown error occurred");
            throw e;
        }
    }

    @action updateFieldsByObject(fields: { [key: string]: string | number | null }): Promise<Horse> {
        const requests = Object.keys(fields).map(key => {
            return { field: key, value: fields[key] === null ? null : `${fields[key]}` };
        });
        return this.updateFields(requests);
    }

    @action async updateFields(fields: Array<PatchRequest>): Promise<Horse> {
        this.setLoading();
        try {
            const horse = await this.horseEndpoints.editHorse(this._horseId, { requests: fields });
            this._horse = horse;
            return horse;
        } catch (e) {
            // Nothing to handle here, pass it back
            throw e;
        } finally {
            this.setReady();
        }
    }

    @action async addHorseForSale(request: CreateHorseForSaleRequest): Promise<Horse> {
        this.setLoading();
        try {
            const horseForSale = await this.horseForSaleEndpoints.createHorseForSale(request);
            return this.refresh();
        } catch (e) {
            // Nothing to handle here, pass it back to the requester to show a message
            throw e;
        } finally {
            this.setReady();
        }
    }

    @computed get horse(): Horse | undefined {
        return this._horse;
    }
}



// WEBPACK FOOTER //
// ./src/stores/HorseStore.ts